/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Uses_External_Case_Identifier_HintInputs */

const en_clients_field_uses_external_case_identifier_hint = /** @type {(inputs: Clients_Field_Uses_External_Case_Identifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shows an external identifier field on this client’s cases.`)
};

const pt_br2_clients_field_uses_external_case_identifier_hint = /** @type {(inputs: Clients_Field_Uses_External_Case_Identifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibe um campo de identificador externo nos casos deste cliente.`)
};

/**
* | output |
* | --- |
* | "Shows an external identifier field on this client’s cases." |
*
* @param {Clients_Field_Uses_External_Case_Identifier_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_uses_external_case_identifier_hint = /** @type {((inputs?: Clients_Field_Uses_External_Case_Identifier_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Uses_External_Case_Identifier_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_uses_external_case_identifier_hint(inputs)
	return pt_br2_clients_field_uses_external_case_identifier_hint(inputs)
});